import { ActionIcon, Button, Tooltip } from '@mantine/core';
import { IconLogout } from '@tabler/icons-react';

import { useAuth } from '@/contexts';

interface LogoutButtonProps {
  iconOnly?: boolean;
}

export function LogoutButton({ iconOnly = false }: Readonly<LogoutButtonProps>) {
  const { logout } = useAuth();

  if (iconOnly) {
    return (
      <Tooltip label="Sign Out" position="bottom">
        <ActionIcon variant="subtle" color="white" size="lg" aria-label="Sign Out" onClick={logout}>
          <IconLogout size={20} />
        </ActionIcon>
      </Tooltip>
    );
  }

  return (
    <Button
      variant="light"
      size="xs"
      radius="md"
      aria-label="Sign Out"
      onClick={logout}
      rightSection={<IconLogout />}
    >
      Sign Out
    </Button>
  );
}
